import React,{useState, useEffect}  from 'react';
import { MdDelete } from "react-icons/md";
import { Link, NavLink } from 'react-router-dom';
import { CiSearch } from "react-icons/ci";
import './commande.css';
import { CustomPagination } from "../../GestionProduits/ProductsTable/ProductsTable";
import BootstrapTable from "react-bootstrap-table-next";
import TableSkeleton from "../../../common/TableSkeleton";
import { IUser } from "../../../../utils/api/user/user.type";
import { DeleteCommande } from "../Administration/modale/hooks/UseAddOrUpdateSubAdminForm";
import { useGetListOrderAdminQuery} from "../../../../utils/api/order/order.api";
import { useAppSelector } from "../../../../redux/hook";
import { formatDate, isAdmin, isPreparateur,formatCurrency} from "../../../../utils/Utils";
import { AiFillEye } from "react-icons/ai";


const Commandes = () => {

  const [search, setSearch] = useState<string>("");
  const { user } = useAppSelector((s) => s?.user);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { data, isLoading, refetch } = useGetListOrderAdminQuery({
    page: page,
    search: search,
    limit: perPage,
  });


  const actionFormatter = (cell: any, row: any) => {
    return (
      <>
        <div className="table-actions-btn-container-commandes d-flex gap-3">
          <div className="container-btn-action-icon-modal">
            <NavLink
              to={`/admin/commandes/${row?.slug}`}
              state={row}
              className="btn btn-action-filter-icon with-tooltip"
              data-tooltip-content="Voir"
            >
              <AiFillEye />
            </NavLink> 
            
          </div>
          <div className="container-btn-action-icon-modal">
            {/* <UpdateSubAdminButton admin={row} /> */}          
          </div>
          <div className="container-btn-action-icon-modal">
            <DeleteCommande item={row} />
          </div>
        </div>
      </>
    );
  };

  const nameFormatter = (cell: string, row: any) => {
    return (
      <div className="table-actions-btn-container-img gap-2">
        
        <p className="text-nom-produit-table mb-0">
          {row?.user ? row?.user?.prenom + " " + row?.user?.nom : row?.prenom_client+" "+row?.nom_client}
        </p>
      </div>
    );
  };

  const vendeurFormatter = (cell: string, row: any) => {
    return (
      <div className="table-actions-btn-container-img gap-2">
        
        <p className="text-nom-produit-table mb-0">
          {row?.vendeur?.prenom + " " + row?.vendeur?.nom}
        </p>
      </div>
    );
  };

  const teleFormatter = (cell: string, row: any) => {
    return (
      <div className="table-actions-btn-container-img gap-2">
        
        <p className="text-nom-produit-table mb-0">
          { row?.user ? row?.user?.telephone : row?.telephone}
        </p>
      </div>
    );
  };

  const dateFormatter = (cell: string, row: any) => {
    return (
      <div className="table-actions-btn-container-img gap-2">
        
        <p className="text-nom-produit-table mb-0">
          {formatDate(row?.date_de_reception) }
        </p>
      </div>
    );
  };

  const columns = [
    
    {
      dataField: "nom",
      text: "Noms",
      formatter: (cell: string, row: IUser) => nameFormatter(cell, row),
    },
    {
      dataField: "telephone",
      text: "Téléphone",
      formatter: (cell: string, row: IUser) => teleFormatter(cell, row),
    },
    {
      dataField: "id",
      text: "Vendeurs",
      formatter: (cell: string, row: IUser) => vendeurFormatter(cell, row),
    },
    {
      dataField: "montant_total",
      text: "Montant Commande",
    },
    {
      dataField: "date_de_reception",
      text: "Date",
      formatter: (cell: string, row: IUser) => dateFormatter(cell, row),
    },
    {
      dataField: "id",
      text: "Actions",
      formatter: (cell: string, row: any) => actionFormatter(cell, row),
    },
  ];

  const onSearchChange =(e:any) =>{
      setSearch(e.target.value) ;
  }

  useEffect(() => {
    if (search) {
        refetch();
    }
  }, [search]);


  return (
    <div className='pt-5'>
      <div className="d-flex justify-content-between m-5 items-center ">
        <h4 className='fw-bold title-form-register '>Commandes</h4>
        <div className="d-flex gap-3 item-center relative">
          <div className="absolute">
            <input type="text" placeholder='Recherche' className='input-vendeur' /><CiSearch className='input-icon me-3' />
          </div>
          <form action="" className="d-flex form item-center gap-3">
            <select
              className="form-select form-input"
              aria-label="Default select example"
            >
              <option selected>filter</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </form>
          <Link to="#">
            <button className='btn btn-commande'>Exporter Les Donnees</button>
          </Link>
        </div>
      </div>
      <div className="m-3">
        {isLoading && <TableSkeleton headers={columns} />}
        {!isLoading && (
          <>
            <BootstrapTable
              keyField="id"
              data={data?.results || []}
              columns={columns}
              striped
              condensed
              hover
              responsive={true}
              wrapperClasses="table-responsive admin-table"
              noDataIndication={() => "Aucune donnée trouvée"}
            />
            <CustomPagination
              nbPages={data?.nbPage}
              page={page}
              onChange={(page, perPage) => {
                setPerPage(perPage);
                setPage(page);
              }}
              perPage={perPage}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Commandes;
